import { render, staticRenderFns } from "./detail-new.vue?vue&type=template&id=4d72201c&scoped=true&"
import script from "./detail-new.vue?vue&type=script&lang=js&"
export * from "./detail-new.vue?vue&type=script&lang=js&"
import style0 from "./detail-new.vue?vue&type=style&index=0&id=4d72201c&prod&scoped=true&lang=css&"
import style1 from "./detail-new.vue?vue&type=style&index=1&id=4d72201c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d72201c",
  null
  
)

export default component.exports